import actions from './actions';
import mutations from './mutations';
import sessionManager from './sessionManager';

const state = {
  idpUri: '',
  redirectUri: '',
  fqdn: '',
  subdomain: '',
  tokenExpiry: 0,
  interruptRefreshToken: false,
  refreshToken: false,
  initialised: false,
  profile: {
    displayName: '',
    name: {
      familyName: '',
      givenName: ''
    },
    email: ''
  },
  token: null,
  isFirstLogin: false,
  isLoginBannerShown: false
};

const getters = {
  //  Check if tokenExpiry is more than 10 minutes away
  isAuthenticated:
    (...args) =>
    () => {
      return args[0].tokenExpiry - new Date().getTime() > sessionManager.tokenExpiryMS();
    },
  // @complispace/cs-design-system use this session getter for existing idp login uri,
  // changes in here might break in @complispace/cs-design-system for existing login
  authorizationUri: (stateData) => {
    const queryParams = `client_id=quicklinks&redirect_uri=${encodeURIComponent(
      stateData.redirectUri
    )}&response_type=token&state=`;
    return `https://${stateData.idpUri}/oauth2/authorize?${queryParams}`;
  },
  // @complispace/cs-design-system use this session getter for existing idp login uri,
  // changes in here might break in @complispace/cs-design-system for existing login
  authorizationUriComplispaceStaff: (stateData) => {
    const queryParams = `client_id=quicklinks&redirect_uri=${encodeURIComponent(
      stateData.redirectUri
    )}&scope=staff.complispace&response_type=token&state=`;
    return `https://${stateData.idpUri}/oauth2/authorize?${queryParams}`;
  },
  refreshToken: (stateData) => stateData.refreshToken,

  user: (stateData) => stateData.profile,

  getXSiteURL: () => () => sessionManager.getXSiteUrl(),

  // this function is use by @complispace/cs-design-system for now
  getToken: (stateData) => {
    return stateData.token || sessionManager.getTokenFromLocalStorage();
  },

  isFirstLogin: (stateData) => {
    return stateData.isFirstLogin;
  },
  isLoginBannerShown: (stateData) => {
    return stateData.isLoginBannerShown;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
